import __request__ from "routing/request";
export function deprecatedDeflector(requestOptions) {
  return __request__("GET", "/system/deflector", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deprecatedCycle(requestOptions) {
  return __request__("POST", "/system/deflector/cycle", null, {}, {
    "Accept": []
  }, requestOptions);
}
export function deflector(indexSetId, requestOptions) {
  return __request__("GET", `/system/deflector/${indexSetId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function cycle(indexSetId, requestOptions) {
  return __request__("POST", `/system/deflector/${indexSetId}/cycle`, null, {}, {
    "Accept": []
  }, requestOptions);
}
